<template>
  <div style="height: 100%">
    <div class="inject-home" v-if="homeShow">
      <div>
        <a-select
          style="width: 100%"
          @change="handleChange"
          :placeholder="$t('edit.injectInfo.typeHolder')"
        >
          <a-select-option value="pic">{{$t('edit.injectInfo.pasterPic')}}</a-select-option>
          <a-select-option value="word">{{$t('edit.injectInfo.pasterText')}}</a-select-option>
          <a-select-option value="video">{{$t('edit.injectInfo.pasterVideo')}}</a-select-option>
        </a-select>
      </div>
      <div class="list-title">{{$t('edit.injectInfo.currentPatsers')}}</div>

      <InjectList
        v-for="(value, k) in currentPaster"
        :key="k"
        :itemObj="value"
        :selectedId="currentInJId"
        @deleteItem="deleteItem"
        @editItem="editItem"
        @click.native="onClickItem(value)"
      ></InjectList>
    </div>
    <InjectImage
      v-if="imageShow"
      :defaultValue="editTarget"
      @clickBack="clickBack"
      @clickDelete="clickDelete"
      @saveDataToStore="saveDataToStore"
      @change="handlePasterChange"
    ></InjectImage>
    <InjectText
      v-if="textShow"
      :defaultValue="editTarget"
      @clickBack="clickBack"
      @clickDelete="clickDelete"
      @saveDataToStore="saveDataToStore"
      @change="handlePasterChange"
    ></InjectText>
    <InjectVideo
      v-if="videoShow"
      :defaultValue="editTarget"
      @clickBack="clickBack"
      @clickDelete="clickDelete"
      @saveDataToStore="saveDataToStore"
      @change="handlePasterChange"
    ></InjectVideo>

    <!--重命名-->
    <!-- <a-modal
      v-model="renameVisible"
      :title="$t('actionTitles.rename')"
      :width="800"
      :destroyOnClose="true"
      @ok="handleConfirm"
    >
      <div style="width: 50%; margin: auto">
        <span style="line-height: 4">原名稱: {{ renameObj.title }}</span>
        <div>
          <a-input
            v-model="newName"
            addonBefore="新名稱"
            placeholder="請輸入新名稱"
          ></a-input>
        </div>
      </div>
    </a-modal> -->
  </div>
</template>

<script>
import InjectImage from "./InjectImage";
import InjectText from "./InjectText";
import InjectVideo from "./InjectVideo";
import InjectList from "./InjectList";
import { mapGetters } from "vuex";

export default {
  components: { InjectVideo, InjectText, InjectImage, InjectList },
  data() {
    return {
      list: [],
      homeShow: true,
      imageShow: false,
      textShow: false,
      videoShow: false,
      cueentTitle: "",
      currentPaster: {},
      renameObj: {},
      newName: "",
      // renameVisible: false,
      editTarget: null,
      currentInJId: "",
      isAddNew: true,
      listType: {
        word: "T",
        pic: this.$t('edit.typeList.picture'),
        video: this.$t('edit.typeList.video'),
      }
    };
  },

  computed: { ...mapGetters(["vrbase", "currentScenesId"]) },
  watch: {
    currentScenesId() {
      this.currentPaster = this.vrbase.scenes[this.currentScenesId].paster;
    },
  },
  created() {
    this.currentPaster = this.vrbase.scenes[this.currentScenesId].paster;
  },
  mounted() {
    this.$bus.$on("clickPaster", (e) => {
      let paster = this.currentPaster[e];
      if (paster) {
        this.onClickItem(paster);
        this.editItem(paster);
      }
    });
  },
  methods: {
    editItem(itemObj) {
      this.handleChange(itemObj.type, false);
      this.editTarget = itemObj;
    },
    onClickItem(value) {
      this.currentInJId = value.paster_id;
      lookto(value.ath, value.atv);
    },
    handleChange(value, isAddNew = true) {
      this.editTarget = null;
      this.isAddNew = isAddNew;
      const typeObj = {
        image: value === "pic",
        text: value === "word",
        video: value === "video",
        ppt: value === "ppt",
      };
      this.homeShow = value === "home";
      this.imageShow = typeObj.image;
      this.textShow = typeObj.text;
      this.videoShow = typeObj.video;
    },
    clickBack(paster) {
      if (this.isAddNew) {
        removePaster(paster.paster_id);
      }
      this.handleChange("home");
    },
    clickDelete(paster) {
      this.deleteItem(paster);
      this.handleChange("home");
    },
    handleListOption(value, option) {
      console.log(value, option);
    },
    // renameItem(selectedItem) {
    //   this.renameObj = selectedItem;
    //   this.renameVisible = true;
    // },
    deleteItem(selectedItem) {
      removePaster(selectedItem.paster_id);
      let paster = this.vrbase.scenes[this.currentScenesId].paster;
      this.$delete(paster, selectedItem.paster_id);
      this.$store.dispatch("setVRBase", this.vrbase);
    },
    saveDataToStore({ key, data }) {
      this.handleChange("home");
      let vrbase = this.vrbase;
      vrbase.scenes[this.currentScenesId].paster[key] = data;
      this.$store.dispatch("setVRBase", vrbase);
      this.$store.dispatch("saveVRBase", {vrbase, showLoading: true});
    },
    handleConfirm() {},
    handlePasterChange(val, oldVal) {
      setPaster(val, oldVal);
    },
  },
};
</script>
